import React from "react";
import type { TransformedProduct } from "../../types/productApiTypes";

interface ProductCardProps {
  product: TransformedProduct;
  viewMode: "grid" | "list"; // Added viewMode prop
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  viewMode, // Destructure viewMode
}) => {
  return (
    <div className={`product-card product-card--${viewMode}`}>
      {" "}
      {/* Apply viewMode class */}
      <a href={product.permalink} className="product-card-link">
        {product.images && product.images.length > 0 ? (
          <img
            src={product.images[0].src}
            alt={product.images[0].alt || product.name}
            className="product-card-image"
          />
        ) : (
          <div className="product-card-image-placeholder">
            <span>No Image</span>
          </div>
        )}
        {/* Wrap text details in a new div */}
        <div className="product-card-details">
          <h3 className="product-card-name">{product.name}</h3>
          {product.subtitle && (
            <p className="product-card-subtitle">{product.subtitle}</p>
          )}
          {/* Conditionally render short description for list view */}
          {viewMode === "list" && product.shortDescription && (
            <div
              className="product-card-short-description"
              dangerouslySetInnerHTML={{ __html: product.shortDescription }}
            />
          )}
          {/* <span className="product-card-view-button">Ürünü İncele</span> */}
        </div>
      </a>
      {/* Add to cart button or other actions can go here */}
    </div>
  );
};

export default ProductCard;
